import { atom } from "jotai";

/**
 * Payload for opening the AMA Guide PDF viewer at a specific location.
 * `token` bumps per click so consumers can `useEffect` on it and re-run
 * their side effects even when the page/query/highlight triple repeats.
 */
export type AmaGuideOpenRequestPayload = {
  page?: number;
  query?: string;
  highlight?: string;
  token: number;
};

/**
 * Cross-surface event bus for AMA Guide PDF viewer open requests.
 *
 * Any surface that wants to open the viewer writes here (today: the
 * chatbot markdown link handlers). `AppointmentDetails` subscribes to
 * open the impairment-rating sidebar that hosts the viewer, and the
 * sidebar itself subscribes to forward the payload into
 * `LearnMoreSection`'s existing `openRequest` plumbing.
 *
 * Null between requests; set to a fresh object on each new click.
 */
export const amaGuideOpenRequestAtom = atom<AmaGuideOpenRequestPayload | null>(
  null,
);
